'use strict';

var $Object = require('es-object-atoms');

/** @type {import('./Object.setPrototypeOf')} */
module.exports = $Object.setPrototypeOf || null;



//////////////////
// WEBPACK FOOTER
// ./node_modules/set-proto/Object.setPrototypeOf.js
// module id = 660
// module chunks = 0